export function getDevice(sku) {
  const deviceMappings = [
    { key: 'SM-A145', device: 'GalaxyA144G' },
    { key: 'SM-A146', device: 'GalaxyA145G' },
    { key: 'SM-A346', device: 'GalaxyA345G' },
    { key: 'SM-A546', device: 'GalaxyA545G' },
    { key: 'SM-S911', device: 'GalaxyS235G' },
    { key: 'SM-S916', device: 'GalaxyS23Plus5G' },
    { key: 'SM-S918', device: 'GalaxyS23Ultra5G' },
    { key: 'SM-S931', device: 'GalaxyS2255G' },
    { key: 'SM-S936', device: 'GalaxyS25Plus5G' },
    { key: 'SM-S938', device: 'GalaxyS25Ultra5G' },
    { key: 'SM-A047', device: 'GalaxyA04s' },
    { key: 'SM-A236', device: 'GalaxyA235G' },
    { key: 'SM-F721', device: 'GalaxyZFlip45G' },
    { key: 'SM-F936', device: 'GalaxyZFold45G' },
    { key: 'SM-M135', device: 'GalaxyM13' },
    { key: 'SM-M336', device: 'GalaxyM335G' },
    { key: 'SM-M536', device: 'GalaxyM535G' },
    { key: 'SM-A135', device: 'GalaxyA13' },
    { key: 'SM-A336', device: 'GalaxyA335G' },
    { key: 'SM-A536', device: 'GalaxyA535G' },
    { key: 'SM-M236', device: 'GalaxyM235G' },
    { key: 'SM-S901', device: 'GalaxyS225G' },
    { key: 'SM-S906', device: 'GalaxyS22Plus5G' },
    { key: 'SM-S908', device: 'GalaxyS22Ultra5G' },
    { key: 'SM-G990', device: 'GalaxyS21FE5G' },
    { key: 'SM-A136', device: 'GalaxyA135G' },
    { key: 'SM-A035', device: 'GalaxyA03' },
    { key: 'SM-M225', device: 'GalaxyM22' },
    { key: 'SM-M526', device: 'GalaxyM525G' },
    { key: 'SM-A037', device: 'GalaxyA03s' },
    { key: 'SM-A528', device: 'GalaxyA52s5G' },
    { key: 'SM-F711', device: 'GalaxyZFlip35G' },
    { key: 'SM-F926', device: 'GalaxyZFold35G' },
    { key: 'SM-A226', device: 'GalaxyA225G' },
    { key: 'SM-M325', device: 'GalaxyM32' },
    { key: 'SM-A526', device: 'GalaxyA525G' },
    { key: 'SM-A725', device: 'GalaxyA72' },
    { key: 'SM-M127', device: 'GalaxyM12' },
    { key: 'SM-A326', device: 'GalaxyA325G' },
    { key: 'SM-G991', device: 'GalaxyS215G' },
    { key: 'SM-G996', device: 'GalaxyS21Plus5G' },
    { key: 'SM-G998', device: 'GalaxyS21Ultra5G' },
    { key: 'SM-A025F', device: 'GalaxyA02s' },
    { key: 'SM-A125', device: 'GalaxyA12' },
    { key: 'SM-A426', device: 'GalaxyA425G' },
    { key: 'SM-G780', device: 'GalaxyS20FE' },
    { key: 'SM-G781', device: 'GalaxyS20FE5G' },
    { key: 'SM-M515', device: 'GalaxyM51' },
    { key: 'SM-F916', device: 'GalaxyZFold2' },
    { key: 'SM-M317', device: 'GalaxyM31s' },
    { key: 'SM-N980', device: 'GalaxyNote20' },
    { key: 'SM-N981', device: 'GalaxyNote205G' },
    { key: 'SM-N986', device: 'GalaxyNote20Ultra5G' },
    { key: 'SM-F707', device: 'GalaxyZFlip5G' },
    { key: 'SM-A217', device: 'GalaxyA21s' },
    { key: 'SM-A415', device: 'GalaxyA41' },
    { key: 'SM-A315', device: 'GalaxyA31' },
    { key: 'SM-A516', device: 'GalaxyA515G' },
    { key: 'SM-M115', device: 'GalaxyM11' },
    { key: 'SM-G980', device: 'GalaxyS20' },
    { key: 'SM-G981', device: 'GalaxyS205G' },
    { key: 'SM-G986', device: 'GalaxyS20Plus5G' },
    { key: 'SM-G988', device: 'GalaxyS20Ultra5G' },
    { key: 'SM-F700', device: 'GalaxyZFlip' },
    { key: 'SM-N770', device: 'GalaxyNote10Lite' },
    { key: 'SM-G770', device: 'GalaxyS10Lite' },
    { key: 'SM-A515', device: 'GalaxyA51' },
    { key: 'SM-A715', device: 'GalaxyA71' },
    { key: 'SM-A307', device: 'GalaxyA30s' },
    { key: 'SM-A908', device: 'GalaxyA905G' },
    { key: 'SM-F907', device: 'GalaxyFold5G' },
    { key: 'SM-N970', device: 'GalaxyNote10' },
    { key: 'SM-N975', device: 'GalaxyNote10Plus' },
    { key: 'SM-N976', device: 'GalaxyNote10Plus5G' },
    { key: 'SM-A705', device: 'GalaxyA70' },
    { key: 'SM-A260', device: 'GalaxyA2Core' },
    { key: 'SM-A205', device: 'GalaxyA20e' },
    { key: 'SM-A405', device: 'GalaxyA40' },
    { key: 'SM-A805', device: 'GalaxyA80' },
    { key: 'SM-G977', device: 'GalaxyS105G' },
    { key: 'SM-A105', device: 'GalaxyA10' },
    { key: 'SM-A305', device: 'GalaxyA30' },
    { key: 'SM-A505', device: 'GalaxyA50' },
    { key: 'SM-G973', device: 'GalaxyS10' },
    { key: 'SM-G975', device: 'GalaxyS10Plus' },
    { key: 'SM-G970', device: 'GalaxyS10e' },
    { key: 'SM-A920', device: 'GalaxyA9' },
    { key: 'SM-J415', device: 'GalaxyJ4Plus' },
    { key: 'SM-N960', device: 'GalaxyNote9' },
    { key: 'SM-A600', device: 'GalaxyA62018' },
    { key: 'SM-G960', device: 'GalaxyS9' },
    { key: 'SM-G965', device: 'GalaxyS9Plus' },
    { key: 'SM-N950', device: 'GalaxyNote8' },
    { key: 'SM-J330', device: 'GalaxyJ32017' },
    { key: 'SM-J530', device: 'GalaxyJ52017' },
    { key: 'SM-G950', device: 'GalaxyS8' },
    { key: 'SM-G955', device: 'GalaxyS8Plus' },
    { key: 'SM-A320', device: 'GalaxyA32017' },
    { key: 'SM-A520', device: 'GalaxyA52017' },
    { key: 'SM-A310', device: 'GalaxyA32016' },
    { key: 'SM-G930', device: 'GalaxyS7' },
    { key: 'SM-G935', device: 'GalaxyS7Edge' },
    { key: 'SM-A510', device: 'GalaxyA52016' },
    { key: 'SM-A530', device: 'GalaxyA8' },
    { key: 'SM-A750', device: 'GalaxyA7' },
    { key: 'SM-A300', device: 'GalaxyA3' },
    { key: 'SM-A500', device: 'GalaxyA5' },
    { key: 'SM-J600', device: 'GalaxyJ6' },
    { key: 'SM-J610', device: 'GalaxyJ6Plus' },
    { key: 'SM-T636', device: 'GalaxyTabActive4Pro5GWi-Fi' },
    { key: 'SM-X706', device: 'GalaxyTabS85GWi-Fi' },
    { key: 'SM-X906', device: 'GalaxyTabS8Ultra5GWi-Fi' },
    { key: 'SM-X900', device: 'GalaxyTabS8UltraWi-Fi' },
    { key: 'SM-X700', device: 'GalaxyTabS8Wi-Fi' },
    { key: 'SM-X806', device: 'GalaxyTabS8Plus5GWi-Fi' },
    { key: 'SM-X800', device: 'GalaxyTabS8PlusWi-Fi' },
    { key: 'SM-X205', device: 'GalaxyTabA84GWi-Fi' },
    { key: 'SM-X200', device: 'GalaxyTabA8Wi-Fi' },
    { key: 'SM-T225', device: 'GalaxyTabA7Lite4GWi-Fi' },
    { key: 'SM-T736', device: 'GalaxyTabS7FE5GWi-Fi' },
    { key: 'SM-T730', device: 'GalaxyTabS7FEWi-Fi' },
    { key: 'SM-T505', device: 'GalaxyTabA74GWi-Fi2020' },
    { key: 'SM-T500', device: 'GalaxyTabA7Wi-Fi2020' },
    { key: 'SM-T220', device: 'GalaxyTabA7LiteWi-Fi' },
    { key: 'SM-T875', device: 'GalaxyTabS74GWi-Fi' },
    { key: 'SM-T870', device: 'GalaxyTabS7Wi-Fi' },
    { key: 'SM-T976', device: 'GalaxyTabS7Plus5GWi-Fi' },
    { key: 'SM-T970', device: 'GalaxyTabS7PlusWi-Fi' },
    { key: 'SM-T580', device: 'GalaxyTabA64GWi-Fi' },
    { key: 'SM-T585', device: 'GalaxyTabA64GWi-Fi' },
    { key: 'SM-T515', device: 'GalaxyTabA10.14GWi-Fi2019' },
    { key: 'SM-T290', device: 'GalaxyTabA8.0Wi-Fi2019' },
    { key: 'SM-T865', device: 'GalaxyTabS64GWi-Fi' },
    { key: 'SM-T867', device: 'GalaxyTabS64GWi-Fi' },
    { key: 'SM-T295', device: 'GalaxyTabA8.04GWi-Fi2019' },
    { key: 'SM-T297', device: 'GalaxyTabA8.04GWi-Fi2019' },
    { key: 'SM-P355', device: 'GalaxyTabA' },
    { key: 'SM-T387', device: 'GalaxyTabA' },
    { key: 'SM-T587', device: 'GalaxyTabA' },
    { key: 'SM-T280', device: 'GalaxyTabA' },
    { key: 'SM-T555', device: 'GalaxyTabA' },
    { key: 'SM-T550', device: 'GalaxyTabA' },
    { key: 'SM-T355', device: 'GalaxyTabA' },
    { key: 'SM-P555', device: 'GalaxyTabA' },
    { key: 'SM-P550', device: 'GalaxyTabA' },
    { key: 'SM-T725', device: 'GalaxyTabS5e4GWi-Fi' },
    { key: 'SM-T835', device: 'GalaxyTabS410.54GWi-Fi' },
    { key: 'SM-T830', device: 'GalaxyTabS4Wi-Fionly' },
    { key: 'SM-W703', device: 'GalaxyTabProS' },
    { key: 'SM-T595', device: 'GalaxyTabA10.54GWi-Fi' },
    { key: 'SM-T590', device: 'GalaxyTabA10.5Wi-Fi' },
    { key: 'SM-T575', device: 'GalaxyTabActive3' },
    { key: 'SM-T720', device: 'GalaxyTabS5eWi-Fi' },
    { key: 'SM-P615', device: 'GalaxyTabS6Lite4GWi-Fi2022' },
    { key: 'SM-P613', device: 'GalaxyTabS6LiteWi-Fi2022' },
    { key: 'SM-T860', device: 'GalaxyTabS6Wi-Fi' },
    { key: 'SM-X626B',device: 'GalaxyTabS10FEPlus5G'},
    { key: 'SM-X620', device: 'GalaxyTabS10FEPlusWi-Fi'},
    { key: 'SM-X526B',device: 'GalaxyTabS10FE5G'},
    { key: 'SM-X520', device: 'GalaxyTabS10FEWi-Fi'},
    { key: 'SM-R510', device: 'GalaxyBuds2Pro' },
    { key: 'SM-R900', device: 'GalaxyWatch5' },
    { key: 'SM-R905', device: 'GalaxyWatch5' },
    { key: 'SM-R910', device: 'GalaxyWatch5' },
    { key: 'SM-R915', device: 'GalaxyWatch5' },
    { key: 'SM-R920', device: 'GalaxyWatch5Pro' },
    { key: 'SM-R177', device: 'GalaxyBuds2' },
    { key: 'SM-R860', device: 'GalaxyWatch4' },
    { key: 'SM-R865', device: 'GalaxyWatch4' },
    { key: 'SM-R870', device: 'GalaxyWatch4' },
    { key: 'SM-R875', device: 'GalaxyWatch4' },
    { key: 'SM-R895', device: 'GalaxyWatch4Classic' },
    { key: 'SM-R890', device: 'GalaxyWatch4Classic' },
    { key: 'SM-R885', device: 'GalaxyWatch4Classic' },
    { key: 'SM-R880', device: 'GalaxyWatch4Classic' },
    { key: 'EI-T730', device: 'GalaxySmartTagPlus' },
    { key: 'SM-R190', device: 'GalaxyBudsPro' },
    { key: 'EI-T530', device: 'GalaxySmartTag' },
    { key: 'SM-R180', device: 'GalaxyBudsLive' },
    { key: 'SM-R845', device: 'GalaxyWatch3' },
    { key: 'SM-R855', device: 'GalaxyWatch3' },
    { key: 'SM-R840', device: 'GalaxyWatch3' },
    { key: 'SM-R850', device: 'GalaxyWatch3' },
    { key: 'SM-R175', device: 'GalaxyBudsPlus' },
    { key: 'SM-R140', device: 'GearIconX2018' },
    { key: 'SM-R820', device: 'GalaxyWatchActive2Bluetooth' },
    { key: 'SM-R830', device: 'GalaxyWatchActive2Bluetooth' },
    // Duplicate keys are maintained in order; the first match wins.
    { key: 'SM-R825', device: 'GalaxyWatchActive2LTE' },
    { key: 'SM-R835', device: 'GalaxyWatchActive2LTE' },
    { key: 'SM-R170', device: 'GalaxyBuds' },
    { key: 'SM-R500', device: 'GalaxyWatchActive' },
    { key: 'SM-R370', device: 'GalaxyFit' },
    { key: 'SM-R375', device: 'GalaxyFite' },
    { key: 'SM-R810', device: 'GalaxyWatch42mm' },
    { key: 'SM-R815', device: 'GalaxyWatch42mm' },
    { key: 'SM-R800', device: 'GalaxyWatch' },
    { key: 'SM-R805', device: 'GalaxyWatch' },
    { key: 'SM-R760', device: 'GearS3frontier' },
    { key: 'SM-R770', device: 'GearS3frontier' },
    { key: 'SM-R365', device: 'GearFit2' },
    { key: 'SM-R220', device: 'GalaxyFit2' },
    { key: 'SP-LSP3', device: 'TheFreestyle' },
    { key: 'SP-LSP7', device: 'ThePremiereLSP7TSingleLaser' },
    { key: 'SP-LSP9', device: 'ThePremiereLSP9TTripleLaser' },
    { key: 'HW-J651', device: 'HW-J651Soundbar' },
    { key: 'HW-N850', device: 'HW-N850Soundbar' },
    { key: 'WAM6500', device: 'R6WirelessSpeaker' },
    { key: 'WAM6501', device: 'R6WirelessSpeaker' },
    { key: 'WAM7500', device: 'R7WirelessSpeaker' },
    { key: 'WAM7501', device: 'R7WirelessSpeaker' },
    { key: 'WAM750', device: 'ShapeM7' },
    { key: 'WAM751', device: 'ShapeM7' },
    { key: 'UBD-K850', device: 'UBD-K8500' },
    { key: 'VS20A95', device: 'BespokeJetVacuumCleaner' },
    { key: 'VC12H40', device: 'VC4000CanisterVacuum' },
    { key: 'VR30T80', device: 'JetBot80' },
    { key: 'VR30T85', device: 'JetBot80Plus' },
    { key: 'VR50T95', device: 'JetBot90AIPlus' },
    { key: 'VS20T75', device: 'Jet75Pet' },
    { key: 'VS15T70', device: 'Jet70Turbo' },
    { key: 'VR20H90', device: 'VR9000ROBOTVC' },
    { key: 'SR20H90', device: 'VR9000ROBOTVC' },
    { key: 'VU08H30', device: 'VU3000Vacuum' },
    { key: 'SM-R950', device: 'GalaxyWatch6Classic' },
    { key: 'SM-R955', device: 'GalaxyWatch6Classic' },
    { key: 'SM-R960', device: 'GalaxyWatch6Classic' },
    { key: 'SM-R965', device: 'GalaxyWatch6Classic' },
    { key: 'SM-R930', device: 'GalaxyWatch6' },
    { key: 'SM-R935', device: 'GalaxyWatch6' },
    { key: 'SM-R940', device: 'GalaxyWatch6' },
    { key: 'SM-F731', device: 'GalaxyZFlip55G' },
    { key: 'SM-F946', device: 'GalaxyZFold55G' },
    { key: 'SM-X710', device: 'GalaxyTabS9Wi-Fi' },
    { key: 'SM-X716', device: 'GalaxyTabS95GWi-Fi' },
    { key: 'SM-X810', device: 'GalaxyTabS9PlusWi-Fi' },
    { key: 'SM-X816', device: 'GalaxyTabS9Plus5GWi-Fi' },
    { key: 'SM-X910', device: 'GalaxyTabS9UltraWi-Fi' },
    { key: 'SM-X916', device: 'GalaxyTabS9Ultra5GWi-Fi' },
    { key: 'SM-S721', device: 'GalaxyS24FE' },
    { key: 'SM-X926B', device: 'GalaxyTabS10Ultra5GWi-Fi' },
    { key: 'SM-X920', device: 'GalaxyTabS10UltraWi-Fi' },
    { key: 'SM-X826B', device: 'GalaxyTabS10+5GWi-Fi' },
    { key: 'SM-X820', device: 'GalaxyTabS10+Wi-Fi' },
    { key: 'SM-R390', device: 'GalaxyFit3' },
    { key: 'SM-A166', device: 'GalaxyA16LTE' },
    { key: 'SM-A566B', device: 'GalaxyA565G' },
    { key: 'SM-A366B', device: 'GalaxyA365G' },
    { key: 'SM-A266B', device: 'GalaxyA265G' },
  ];

  for (const { key, device } of deviceMappings) {
    if (sku.includes(key)) {
      return device;
    }
  }

  return '';
}
